import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { EsignatureConfigView } from "./EsignatureConfigView";
import { EsignatureConfigViewStore } from "../../store/EsignatureConfigViewStore";
import { useStore } from "../../../../hooks";

export const EsignatureConfigViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/esignatureConfig/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new EsignatureConfigViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <EsignatureConfigView esignatureConfigViewStore={store} />
      </PageLayout>
    </div>
  );
});
